import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import ConjugationTable from "src/components/tables/ConjugationTable";
import ReflexiveVerbCard from "src/components/cards/ReflexiveVerbCard";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle"; // Import the ExampleTitle component
import {
  reflexiveVerbExplanation,
  reflexivePronouns,
  reflexiveVsNonReflexive,
  reflexiveVerbExamples,
  reflexiveVerbsRegular,
  reflexiveVerbsIrregular,
} from "src/data/individual-topics/ReflexiveVerbs";
import PronounTable from "src/components/tables/PronounTable";

const ReflexiveVerbsContent: React.FC = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <div className={`${isDarkMode ? "dark" : ""}`}>
      <div className="section">
        <ExplanationCard cardData={reflexiveVerbExplanation} />
      </div>

        <div className="section">
          <PronounTable tableData={reflexivePronouns} />
        </div>

      <div className="section">
        <ExampleTitle title="Reflexive vs Non-Reflexive" />
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {reflexiveVsNonReflexive.map((item, index) => (
            <ReflexiveVerbCard key={index} verbData={item} />
          ))}
        </div>
      </div>

      <div className="section">
        <ExampleTitle title="Examples of Reflexive Verbs" />
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {reflexiveVerbExamples.map((example, index) => (
            <ExampleCard key={index} example={example} />
          ))}
        </div>
      </div>

      <div className="section">
        <ConjugationTable tableData={{ title: "Regular Reflexive Verbs", verbs: reflexiveVerbsRegular }} />
      </div>

      <div className="section">
        <ConjugationTable tableData={{ title: "Irregular Reflexive Verbs", verbs: reflexiveVerbsIrregular }} />
      </div>
    </div>
  );
};

const ReflexiveVerbsScreen: React.FC = () => {
  return (
    <PageStructure
      TitleNode="Reflexive Verbs"
      Page={<ReflexiveVerbsContent />}
    />
  );
};

export default ReflexiveVerbsScreen;
